import React from "react";
import { CircleCheck, X } from "lucide-react";

export default function OrderSuccessModal({ order, onClose }) {
    if (!order) return null;

    return (
        <div
            data-testid="order-success-modal"
            className="fixed inset-0 z-50 bg-forest-900/80 backdrop-blur-sm flex items-center justify-center p-4 animate-float-up"
            onClick={onClose}
        >
            <div
                className="bg-white rounded-3xl max-w-md w-full p-6 sm:p-8 space-y-5 text-center shadow-2xl border border-forest-100 relative"
                onClick={(e) => e.stopPropagation()}
            >
                <button
                    onClick={onClose}
                    aria-label="Close"
                    className="absolute top-4 right-4 w-8 h-8 rounded-full bg-forest-50 text-forest-700 flex items-center justify-center hover:bg-forest-100"
                >
                    <X className="w-4 h-4" />
                </button>

                <div className="w-16 h-16 rounded-full bg-forest-50 text-forest-700 text-3xl flex items-center justify-center mx-auto">
                    <CircleCheck className="w-9 h-9 fill-forest-100" />
                </div>

                <div>
                    <span className="text-xs font-bold uppercase tracking-widest text-forest-700 block">
                        Order Placed Successfully
                    </span>
                    <h3 className="font-serif text-2xl font-bold text-forest-800">
                        Thank you for your order!
                    </h3>
                </div>

                <div className="bg-cream p-4 rounded-2xl border border-forest-100 text-left space-y-2 text-xs">
                    <Row label="Order Number" value={`#${order.order_number}`} />
                    <Row label="Customer Name" value={order.customer_name} />
                    <Row label="Package" value={order.bundle_label} />
                    <Row label="City" value={order.city} />
                    <div className="flex justify-between border-t border-forest-100 pt-2 text-sm font-bold text-forest-800">
                        <span>Total Cash on Delivery:</span>
                        <span>{order.total_price.toLocaleString()} PKR</span>
                    </div>
                </div>

                <p className="text-xs text-forest-900/70">
                    Our logistics team will dispatch your parcel shortly.
                    Expected delivery in{" "}
                    <strong className="text-forest-800">
                        2–3 business days
                    </strong>
                    .
                </p>

                <div className="space-y-2">
                    <a
                        data-testid="modal-track-order-link"
                        href={`/track-order?order=${order.order_number}`}
                        className="w-full bg-forest-700 hover:bg-forest-800 text-gold-400 text-xs font-bold py-3 px-4 rounded-xl flex items-center justify-center gap-2 shadow border border-gold-500/40"
                    >
                        Track this order
                    </a>
                    <button
                        onClick={onClose}
                        data-testid="modal-close-btn"
                        className="w-full bg-cream hover:bg-forest-50 text-forest-800 text-xs font-bold py-2.5 px-4 rounded-xl border border-forest-100"
                    >
                        Close Window
                    </button>
                </div>
            </div>
        </div>
    );
}

function Row({ label, value }) {
    return (
        <div className="flex justify-between text-forest-900/60">
            <span>{label}:</span>
            <span className="font-bold text-forest-800">{value}</span>
        </div>
    );
}
